import { CancelToken } from 'axios';
import { useQuery } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { VIDEO_INTEGRATION_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { createQueriedURL } from '~/Helpers/String.helper';
import { useProvider } from '~/Hooks';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { IVODResponse } from '~/Models/DTO/VideoOnDemand.models';

export const useRequestVOD = (cancelToken?: CancelToken) => {
  const { currentProvider } = useProvider();
  const providerId = currentProvider?.uuid;

  const { isLoading, error, data, refetch, isFetched } = useQuery(
    REQUEST_ACTIONS.GET_VOD_INTEGRATIONS_LIST,
    async () =>
      requestReactQuery<IVODResponse[]>({
        url: createQueriedURL(VIDEO_INTEGRATION_SERVICE_URLS.VOD_INTEGRATIONS, {
          providerId,
        }),
        config: { method: 'GET', cancelToken },
      }),
  );

  return {
    vodLoading: isLoading,
    hasVODLoaded: isFetched,
    vodError: error as IErrorResponse,
    vodIntegrations: data || [],
    refetchVOD: refetch,
  };
};
